
.container {
  width: 30rem;
  background-color: var(--static-background-standard);
  padding: 1rem;
  border-radius: 1rem;
}

